import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { InvoiceListTotalTTCCell } from './invoice-list-total-ttc.cell';
import { InvoiceListTotalTTCHeader } from './invoice-list-total-ttc.header';

export const InvoiceListTotalTTCColumn: IdentifiedColumnDef<
  InvoiceModel,
  InvoiceModel['totalTTC']
> = {
  enableSorting: true,
  header: InvoiceListTotalTTCHeader,
  cell: InvoiceListTotalTTCCell,
  meta: { maxWidth: '80px' },
};
